// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import KeyboardShortcutSequence from './keyboard_shortcuts_sequence';

export * from './keyboard_shortcuts';
export default KeyboardShortcutSequence;
